import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { EventApi } from '@fullcalendar/core';
import { AllocationCard, AllocationStatus, AllocationView, AllocationViewColorField, AllocationViewOrientation, AllocationViewType, AllocationWithMeta, BookingStatus, ColorUtility, Source, UnallocatedUserId } from '@jms/model';
import { AllocationUtility } from '@jms/shared/module.scheduling.allocations.pro/src/helpers';
import { CardColorPipe } from '@jms/utils/util.pipes/src/card.color.pipe';

@Component({
    selector: 'event-card',
    templateUrl: './event.card.component.html',
    styleUrls: ['./event.card.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EventCardComponent {

    @Input() public view: AllocationView = { card: { color: AllocationViewColorField.JobType, address: true, customer: true, customerWO: true, tags: true } } as any;;
    @Input() public event: EventApi;
    @Input() public timezone: string;

    @HostBinding('class.selected')
    get selected() {
        return this.event?.extendedProps?.selected;
    }

    public get cardBottomStyle() {
        if (this.allocation?.status === AllocationStatus.Overhead) {
            return {
                'height': '0px'
            };
        }

        return {
            'background-color': this?.cardColorPipe.transform(this?.allocation, this.view),
            'height': '7px'
        }
    }

    public get allocation(): AllocationCard | AllocationWithMeta {
        return this.event?.extendedProps?.entity;

    }

    public get cardStyle() {
        const overheadColor = this?.allocation?.overhead?.color;
        return {
            'background-color': overheadColor ?? '#ffffff',
            'color': overheadColor ? ColorUtility.idealTextColor(overheadColor) : '#444'
        }
    }

    public get colorTagStyle() {

        const color = this.cardColorPipe.transform(this.allocation, this.view);

        return {
            'background-color': color,
            'color': color ? ColorUtility.idealTextColor(color) : '#EAEAEA'
        };
    }

    public get showDashed() {
        return this.allocation?.bookingStatus == BookingStatus.Tentative;
    }

    public get cardClass() {
        return {
            timeline: this.view?.type === AllocationViewType.Timeline,
            agenda: this.view?.type === AllocationViewType.Agenda,
            vertical: this.view?.orientation === AllocationViewOrientation.Vertical,
            horizontal: this.view?.orientation === AllocationViewOrientation.Horizontal,
            completed: this?.allocation?.status === AllocationStatus.Completed,
            overhead: this?.allocation?.status === AllocationStatus.Overhead
        }
    }

    @HostBinding('class.is-shadow')
    public get isShadow() {
        return AllocationUtility.isShadow(this.allocation);
    }

    public readonly AllocationViewType = AllocationViewType;
    public readonly Source = Source;
    public readonly unallocatedUserId = UnallocatedUserId;

    constructor(
        private cardColorPipe: CardColorPipe,
    ) { }


}
